import React from 'react';
import { WixCapitalDealerBanner as WixCapitalDealerBannerUI } from '@wix/app-market-components';
import { useWixCapitalDealerBanner } from '../../hooks/use-wix-capital-dealer-banner';

export function WixCapitalDealerBanner() {
  const { assets, parsedCtaUrl, onPrimaryCtaClick } =
    useWixCapitalDealerBanner();

  return (
    <WixCapitalDealerBannerUI
      assets={assets ?? undefined}
      parsedCtaUrl={parsedCtaUrl}
      onPrimaryCtaClick={onPrimaryCtaClick}
    />
  );
}
